import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import owlCarousel from "owlcarousel";
import PageTemplate from 'text!../../../templates/featurePage/FeaturePageForListenerTemplate.html';
import OneSlidePageTemplate from 'text!../../../templates/featurePage/FeaturePageForListenerTemplateImageBackgroundv2.html';
import RolloutHelper from "models/helper/FeatureRolloutHelper";
import ti18n from "i18n!nls/FeaturePageForListeneri18n";

const Rollout =  RolloutHelper.getInstance();
const SHOW_ONE_SLIDE_WITH_VAUE_PROP = Rollout.isFeatureEnabled(Rollout.FEATURES.SHOW_ONE_SLIDE_WITH_VAUE_PROP_AFTER_SPASHSCREEN);
const FeaturePageView = Backbone.View.extend({

    template : _.template(SHOW_ONE_SLIDE_WITH_VAUE_PROP? OneSlidePageTemplate: PageTemplate),


initialize : function() {

},

  onOrientationChangeFunction : function(newViewPortHeigh) {
    if (this.$el) {
        this.$el.find(".featureBoxWrapper").css("height",  window.getDocumentClienHeight() + "px");
        this.$el.find("#featuresCarousel").css("height",  window.getDocumentClienHeight() + "px");
        
        
    }
},

events : {
    "click #finishButton" : "onFinishButtonClicked",
    "click #nextButton" : "onNextButtonClicked",
    "click #previousButton" : "onPreviousButtonClicked"
},

onFinishButtonClicked : function(){
    this.trigger("showDefaultPage");
},

onNextButtonClicked : function(){
    if(this.carousel$el){
        const carouselData =  this.carousel$el.data('owlCarousel');
        carouselData.next();
    }
},

onPreviousButtonClicked : function(){
    if(this.carousel$el){
        const carouselData =  this.carousel$el.data('owlCarousel');
        carouselData.prev();
    }
},


onBeforeRemoveFromPage : function(){
    this.trigger("beforeRemoveFromPage", this);
},

onRemovedFromPage : function(){
     this.undelegateEvents();
     this.$el.removeData().unbind(); 
     this.removeKeyboardControl();
     window.removeEventListener('resize', window[this._onViewportHeightChangedFunctionRef] );
     this.trigger("removedFromPage", this);
},


_onPageCreated: function(){
    this.$el.css("padding" , "0px");
},

_onCarouselMove: function(){
    if(this.carousel$el){
        const carouselData =  this.carousel$el.data('owlCarousel');
        if(carouselData && carouselData.owl){
            if(carouselData.owl.currentItem == (carouselData.owl.owlItems.length -1)){
                
                this.$el.find("#nextButton").hide();
                this.$el.find("#finishButton").show();
            }else{
                this.$el.find("#finishButton").hide();
                this.$el.find("#nextButton").show();
            }
            
            if(carouselData.owl.currentItem == 0){
                this.$el.find("#previousButton").hide();
            }else{
                this.$el.find("#previousButton").show();
            }
        }
    }
},

addKeyboardControl : function(){
    $(document).on('keydown.#featuresCarousel', (function(e) {
        if(e.keyCode == 37) {
            if(this.$el.find("#previousButton").is(":visible")){
                this.onPreviousButtonClicked();
            }
        }
        if(e.keyCode == 39) {
            if(this.$el.find("#finishButton").is(":visible")){
                this.onFinishButtonClicked();
            }else{
                this.onNextButtonClicked();
            }
           
        }
    }).bind(this));

},
removeKeyboardControl : function(){
    $(document).off('keydown.#featuresCarousel');

},

_onPageShow: function(){
    $.mobile.resetActivePageHeight(); 
},

render : function(){
    this.$el.find("#nextButton").hide();
    this.$el.find("#previousButton").hide();
    this.$el.find("#finishButton").hide();
    this.$el.html(this.template({"ti18n": ti18n}));
    this.setElement(this.$el.find("div").first());
    this.$el.page({create: this._onPageCreated.bind(this)});
    const functionUniqueGlobalName = "onViewportHeightChangeForFeaturePageViewPage"+ (new Date()).getTime();
    window[functionUniqueGlobalName] =  this.onOrientationChangeFunction.bind(this)
    this._onViewportHeightChangedFunctionRef = functionUniqueGlobalName;
    window.addEventListener('resize', window[functionUniqueGlobalName]  );
    this.carousel$el = this.$el.find("#featuresCarousel").first().owlCarousel({
         
          navigation : false, // Show next and prev buttons
          pagination :true,
          slideSpeed : 300,
          paginationSpeed : 400,
          afterAction : this._onCarouselMove.bind(this),
          singleItem:true
        });
    this.onOrientationChangeFunction(window.getDocumentClienHeight());
    this.addKeyboardControl();
    this.$el.on("pagehide", this._onPageHide.bind(this));
    this.$el.on("pageshow", this._onPageShow.bind(this));
    return this;
},

_onPageHide : function(){
        this.onBeforeRemoveFromPage();
        this.remove();
        this.onRemovedFromPage();
    
},
    });
export default FeaturePageView;